import {forwardRef, HTMLProps, Ref} from 'react';
import {twMerge} from '../../../../common/twMerge';

function SkeletonMain(
  {className, ...rest}: HTMLProps<HTMLDivElement>,
  ref: Ref<HTMLDivElement>
) {
  return (
    <div
      ref={ref}
      className={twMerge(
        'rounded-8pxr bg-[rgb(var(--colors-static-mono-40)_/_15%)]',
        className
      )}
      {...rest}
    />
  );
}

export const Skeleton = forwardRef(SkeletonMain);
